/*
 * @Author: your name
 * @Date: 2021-05-29 15:17:37
 * @LastEditTime: 2021-09-10 11:34:01
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \dc-wsy-pet-raise-plan-front\src\i18n\langs\zhEn.js
 */

module.exports = {
    langauge: 'English',
    title0: 'EASY TO PLAY',
    text0: 'Estimate the best paths and angles to bring out the most explosive effect!',
    title1: 'RECRUIT NEW HEROES',
    text1: 'Assemble your team and be a creative commander!',
    title3: 'LIVE PVP BATTLES',
    text3: 'Fight fierce battles against players from around the world with your skills!',
    title2: 'UNLOCK UNIQUE SKILLS',
    text2: 'Take advantage of every hero and lead them to victory!',
    title4: 'ICONIC ARENAS',
    text4: 'Be the ruler of every spectacular Arena!',
    news_title: 'Information Center',
    home: 'Home',
    next: 'Next >',
    pre: '< Prev',
    record: 'Total of {total} Records',
    service: 'TERMS OF SERVICE',
    privacy: 'PRIVACY POLICY',
    top: 'Top',
    news_langs: 'Language',
    news_null: 'No Data',
    logo: 'Hero Bump',
    contact: 'Contact Customer Service'
}
